export const SELF_ONBOARDING_EMAIL_STORAGE_KEY = 'plg-self-onboarding-email';
export const SELF_ONBOARDING_TICKET_STORAGE_KEY = 'plg-self-onboarding-branding-ticket';
export const SELF_ONBOARDING_VERIFIED_TOKEN_STORAGE_KEY = 'plg-self-onboarding-verified-token';
export const SELF_ONBOARDING_FOUNDER_NAME_STORAGE_KEY = 'plg-self-onboarding-founder-name';
export const SELF_ONBOARDING_COMPANY_NAME_STORAGE_KEY = 'plg-self-onboarding-company-name';
export const SELF_ONBOARDING_DISPLAY_READY_STORAGE_KEY = 'plg-self-onboarding-display-ready';

/** Matches backend skip-branding default. */
export const SELF_ONBOARDING_DEFAULT_COLOR = '#4F46E5';

export const SELF_ONBOARDING_DEFAULT_LOGO_URL =
  'https://kincode-prod.s3.eu-central-1.amazonaws.com/PH_Wordmark-Blue_.png';

export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const HEX_COLOR_REGEXP = /^#[0-9A-Fa-f]{6}$/;
export const HTTPS_URL_REGEXP = /^https?:\/\/.+/i;
